import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class MyProfileService {

  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }

  getProfileDetails(emailId: string): Observable<any>{
    return this.apiService.get(`Userprofiles/UserProfileByUserName/${emailId}`);
  }

  getProfileDetailsByUserProfileId(id: number): Observable<any>{
    return this.apiService.get(`Userprofiles/${id}`);
  }

  getStateName(stateId: number): Observable<any>{
    return this.apiService.get(`Userprofiles/GetStateName/${stateId}`);
  }

  updateProfile(body: any, id: number): Observable<any>{
    return this.apiService.put(`userprofiles/UpdateMyProfile/${id}`, body)
  }
}
